import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import App from './App';
import { config as Config, prefix } from "./config/config";
import reportWebVitals from './reportWebVitals';
//css
import './styles/style.scss';

import common_en from './i18n/translations/en/common.json';


// init translation with default fallback lang EN
i18next.init({
    interpolation: { escapeValue: false },
    fallbackLng: 'en',
    lng: Config.defaultLanguage,
    resources: {
        en: {
            common: common_en
        }
    },
});

//add allowed languages from config dynamically
Config.languages.forEach(lang => {
    const resources = require(`./i18n/translations/${lang}/common.json`);
    i18next.addResourceBundle(lang, 'common', resources, true, true)
});

ReactDOM.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <div className={prefix}>
            <App />
        </div>
      </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
